import { NgModule } from '@angular/core';
import { MaterialModule } from '@material';
import { RouterLinkDirective } from '@utils/directives/router-link.directive';
import { SelectedTabDirective } from '@utils/directives/selected-tab.directive';
import { TrackClickDirective } from '@utils/directives/track-click.directive';
import { TrackEventDirective } from '@utils/directives/track-event.directive';
import { AutoFocusDirective } from '@utils/directives/auto-focus.directive';
import { SetInformationAsReadDirective } from '@utils/directives/set-information-as-read.directive';
import { ContextualInfoDirective } from '@utils/directives/contextual-info.directive';
import { GlossaryDirective } from '@utils/directives/glossary.directive';

export * from '@utils/directives/router-link.directive';
export * from '@utils/directives/selected-tab.directive';
export * from '@utils/directives/auto-focus.directive';
export * from '@utils/directives/set-information-as-read.directive';
export * from '@utils/directives/contextual-info.directive';
export * from '@utils/directives/glossary.directive';

@NgModule({
  imports: [MaterialModule],
  providers: [],
  declarations: [
    RouterLinkDirective, 
    TrackClickDirective, 
    TrackEventDirective, 
    SelectedTabDirective, 
    AutoFocusDirective, 
    SetInformationAsReadDirective,
    ContextualInfoDirective,
    GlossaryDirective],
  exports: [
    RouterLinkDirective,
     TrackClickDirective, 
     TrackEventDirective, 
     SelectedTabDirective, 
     AutoFocusDirective, 
     SetInformationAsReadDirective,
     ContextualInfoDirective,
     GlossaryDirective]
})
export class DirectivesModule {}
